module.exports = __webpack_public_path__ + "assets/img/img_2020.5f239047.jpg";